import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useFlashSalesOnPDP() {
  const experiments = useExperiments()

  return computed(() => experiments['experiment.flashSalesOnPDP'] === 'enabled')
}
